const observerOptions = {
  threshold: 0.3 
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.remove('opacity-0', '-translate-y-10', '-translate-x-20');
      entry.target.classList.add('opacity-100', 'translate-y-0', 'translate-x-0');
    }
  });
}, observerOptions);

document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));